import React, {useCallback, useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForMonitoring
} from "../../../util/Validations";
import {ThinClientOverviewContext} from "../context/ThinClientOverviewContext";
import DatePicker from "@amzn/meridian/date-picker";
import TimePicker from "@amzn/meridian/time-picker";
import addDays from "date-fns/addDays"
import format from "date-fns/format"
import Textarea from "@amzn/meridian/textarea";
import {formatDate} from "../../../util/Util";

const DisableMonitoringModal = (props) => {

    const {formatMessage} = props.intl;
    const {dispatch} = useContext(ThinClientOverviewContext);
    const [valueDateFrom, setValueDateFrom] = useState("")
    const [valueTimeFrom, setValueTimeFrom] = useState("")
    const [valueDateTo, setValueDateTo] = useState("")
    const [valueTimeTo, setValueTimeTo] = useState("")
    const [reason, setReason] = useState("")
    const [reload, setReload] = useState(false)
    const [show, setShow] = useState(false)
    const formatIso = date => format(date, "yyyy-MM-dd")
    const yesterday = formatIso(addDays(new Date(), -1))
    const today = formatIso(new Date())
    const tomorrow = formatIso(addDays(new Date(), 1))
    const sevenDaysFromNow = formatIso(addDays(new Date(), +7))

    const onCloseModal = useCallback(() =>
        props.onStateChange(false), [])

    function onClickCancel() {
        setShow(false);
        props.onStateChange(false)
        setInputState();
    }

    const stateValues = {
        "startTime": formatDate(valueDateFrom) + " " + valueTimeFrom,
        "endTime": formatDate(valueDateTo) + " " + valueTimeTo,
        "reason": reason
    }

    const onClickConfirm = useCallback(async (stateValues, mac) => {
        setShow(true)
        if (checkModalValidationsForMonitoring(stateValues)) {
            stateValues.deviceConfig = JSON.stringify(stateValues.deviceConfig)
            addData(stateValues, mac);
            props.onStateChange(false)
            setInputState();
            setShow(false);
            setReload(true);
            getData();
        }
    }, [reload]);

    function setInputState() {
        // setting state of input fields as empty to have empty inputs on clicking Add Device again
        setValueDateFrom("")
        setValueTimeFrom("")
        setValueTimeTo("")
        setValueDateTo("")
        setReason("")
    }

    const addData = (stateValues, mac) => {
        dispatch({type: 'ADD_DEVICE_DATA', data: {dispatcher: dispatch, stateValues: stateValues, mac: mac}})
    }
    const getData = () => {
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "device.monitoring_modal"})}
                open={props.state}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.start"
                                              defaultMessage="Start Time in UTC Format: MM/DD/YYYY HH:MM:SS"/>
                        </Text>
                        <Row>
                            <DatePicker
                                value={valueDateFrom}
                                onChange={setValueDateFrom}
                                label="Date"
                                presets={[
                                    {label: "Yesterday", value: yesterday},
                                    {label: "Today", value: today},
                                    {label: "Tomorrow", value: tomorrow},
                                    {label: "Next week", value: sevenDaysFromNow},
                                ]}
                                monthsInView={2}
                                locale="en-US"
                            />
                            <TimePicker
                                placeholder="Time"
                                value={valueTimeFrom}
                                onChange={setValueTimeFrom}
                                invalidInputMessage="The Trip Start value is not a valid time. The correct time format is hour:minute AM/PM."
                                width={300}
                                format={{hour: "2-digit", minute: "2-digit", second: "2-digit"}}
                                showIcon={false}
                                label="Time"
                            />
                        </Row>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.end"
                                              defaultMessage="End Time in UTC Format: MM/DD/YYYY HH:MM:SS"/>
                        </Text>
                        <Row>
                            <DatePicker
                                value={valueDateTo}
                                onChange={setValueDateTo}
                                label="Date"
                                presets={[
                                    {label: "Yesterday", value: yesterday},
                                    {label: "Today", value: today},
                                    {label: "Tomorrow", value: tomorrow},
                                    {label: "Next week", value: sevenDaysFromNow},
                                ]}
                                monthsInView={2}
                                locale="en-US"
                            />
                            <TimePicker
                                placeholder="Time"
                                value={valueTimeTo}
                                onChange={setValueTimeTo}
                                invalidInputMessage="The Trip Start value is not a valid time. The correct time format is hour:minute:second AM/PM."
                                width={300}
                                format={{hour: "2-digit", minute: "2-digit", second: "2-digit"}}
                                showIcon={false}
                                label="Time"
                            />
                        </Row>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.reason"
                                              defaultMessage="Reason"/>
                        </Text>
                        <Textarea
                            id="my-input"
                            value={reason}
                            onChange={setReason}
                            type="text"
                        />
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForMonitoring(stateValues) &&
                            show &&
                            <Alert type="warning"
                                   size="small">
                                <FormattedMessage id="alert.missingfields"
                                                  defaultMessage="Please enter all fields in correct format!"/>
                            </Alert>}
                        {!(stateValues.startTime <= stateValues.endTime) &&
                            show &&
                            <Alert type="warning"
                                   size="small">
                                <FormattedMessage id="alert.time" defaultMessage="Confirm"/>
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onClickCancel}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary"
                                size="medium"
                                onClick={() => onClickConfirm(stateValues, props.mac)}>
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DisableMonitoringModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/modal/DisableMonitoringModal.js